var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3071 0.54289L27.7776 7.07244L27.7625 6.21352C27.7313 4.43224 26.2629 3.01432 24.4816 3.04549L3.78035 3.40669C1.99907 3.43787 0.581146 4.90632 0.612321 6.6876L0.802596 17.586C0.833771 19.3672 2.30222 20.7852 4.0835 20.754L24.7848 20.3928C26.566 20.3616 27.984 18.8932 27.9528 17.1119L27.9496 16.898L34.3071 23.2555C34.5178 23.4662 34.8779 23.3168 34.8779 23.019V0.780465C34.879 0.481615 34.5178 0.33219 34.3071 0.54289ZM5.55517 11.0016C4.105 11.0016 2.92895 9.82552 2.92895 8.37535C2.92895 6.92517 4.105 5.74912 5.55517 5.74912C7.00535 5.74912 8.1814 6.92517 8.1814 8.37535C8.1814 9.82552 7.00535 11.0016 5.55517 11.0016Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/video-call-icon.d09ae75b701d3687f5375a71f843e934.svg";
export { ForwardRef as ReactComponent };